import { render, staticRenderFns } from "./BotMessage.vue?vue&type=template&id=213ebee8&"
import script from "./BotMessage.vue?vue&type=script&lang=js&"
export * from "./BotMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports